<script lang="ts">
    import { _ } from "svelte-i18n"
    import { getCachedEntries } from "../../../../api"
    import { langField } from "../../../../i18n"
    import { highlightImageUrl } from "../../../../utils"

    let { product }: { product: Product } = $props()
    let highlights: Highlight[] = $state([])
    getCachedEntries("highlight", { identifier: { $in: product.highlights.map((h) => Number(h)) } }, "identifier").then(
        (res) => {
            highlights = res
        }
    )
</script>

{#if highlights?.length}
    <section>
        <h2 class="h3" id="product-highlights">{$_("product.highlights")}</h2>
        <ul>
            {#each highlights as highlight, idx}
                <li class="highlight">
                    <img src={highlightImageUrl(highlight)} alt="Highlight Nr. {idx}" loading="lazy" />
                    <h4>{langField(highlight.name)}</h4>
                </li>
            {/each}
        </ul>
    </section>
{/if}

<style lang="less">
    @import "../../../../css/variables.less";
    section {
        display: flex;
        flex-direction: column;
        gap: 1.2rem;
        padding: 2.4rem 0px;

        ul {
            display: grid;

            gap: 2.4rem;
            grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
            @media (max-width: 1900px) {
                grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
            }

            .highlight {
                display: flex;
                flex-direction: column;
                gap: 0.6rem;

                img {
                    height: 200px;
                    border-radius: 4px;
                    object-fit: cover;
                }
                h4 {
                    line-height: normal;
                }
            }
            @media @max-mobile {
                grid-template-columns: 1fr;
                .highlight {
                    max-width: 100%;
                }
            }
        }
    }
</style>
